import React from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from 'primereact/button';
import { JVDropdown } from '../../shared/JVDropdown';

interface IProps {
    filters: IAssignmentMastFilter,
    setFilters: (filters: IAssignmentMastFilter) => void,
    loading: boolean,
    // setLoading: (is: boolean) => void
    reload: boolean,
    setReload: (is: boolean) => void
}


export interface IAssignmentMastFilter {
    department?: string | null,
    status?: boolean | null
}
export const EmptyAssignmentMastFilter: IAssignmentMastFilter = {
    department: null,
    status: null
}

const schema = yup.object().shape({

})

const department = [{ label: "Salse", value: "Sales" }, { label: "Recruiter", value: "Recruiter" },]
const Status = [{ label: "Yes", value: true }, { label: "No", value: false },]

export const Filter = (props: IProps) => {
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IAssignmentMastFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const onSubmit = (data: IAssignmentMastFilter) => {
        props.setFilters(data);
    }

    const emptyFilter = () => {
        reset(EmptyAssignmentMastFilter)
        props.setFilters(EmptyAssignmentMastFilter);
        props.setReload(!props.reload);
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDropdown column={6} label='Department' name='department' control={control} options={department} optionLabel='label' optionValue='value' placeholder='-- Select Department --' />
            <JVDropdown column={6} label='Active' name='status' control={control} options={Status} optionLabel='label' optionValue='value' placeholder='-- Select Active Status --' />
            <Button style={{ width: '100px', height:"35px"}} className='mt-5' label="SEARCH" type="submit" loading={props.loading}></Button>
            <Button style={{ width: '100px', height:"35px" }} className="p-button-outlined surface-200 mt-5 ml-3" label="CLEAR" onClick={emptyFilter} type="button"></Button>
           
        </form>
    )
}

